import React, { createContext } from "react";

import { PARTNER, PartnerType } from "@tm/isomorphic-utils";

export const PartnerContext = createContext<PartnerType | null>(null);

export const PartnerContextProvider: React.FC<{
  hostname?: string;
  children: React.ReactNode;
  partnerType?: any;
}> = ({ hostname, children, partnerType }) => {
  React.useEffect(() => {
    const element = document.getElementById("pageId") as HTMLElement;
    element.classList.remove("mmtTheme", "giTheme", "myBizTheme");
    if (partnerType === PARTNER.MYBIZ) {
      element.classList.add("myBizTheme");
    } else if (partnerType === PARTNER.MMT) {
      element.classList.add("mmtTheme");
    } else if (partnerType === PARTNER.GI) {
      element.classList.add("giTheme");
    }
  }, [partnerType]);

  return (
    <PartnerContext.Provider value={partnerType}>
      {children}
    </PartnerContext.Provider>
  );
};
